var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _vm.isPopular
      ? _c("div", { staticClass: "most-popular" }, [_vm._v("Most Popular")])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: {
          "plan-container": true,
          "is-popular": _vm.isPopular,
          mobile: _vm.isMobile(_vm.$mq)
        },
        attrs: { id: _vm.planType + "-plan-card" }
      },
      [
        _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.planTitle))]),
        _vm._v(" "),
        _c("h3", { staticClass: "plan-price" }, [
          _vm._v("\n      " + _vm._s(_vm.price) + " "),
          _c("span", { staticClass: "strikethrough-price" }, [
            _vm._v(_vm._s(_vm.strikethroughPrice))
          ])
        ]),
        _vm._v(" "),
        _vm._t("plan-billing-blurb"),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "checkout-btn btn btn-green",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.handleClick($event)
              }
            }
          },
          [
            _vm._v(
              "\n      Start my free " +
                _vm._s(_vm.user.trial_length) +
                " days\n    "
            )
          ]
        ),
        _vm._v(" "),
        _vm.shouldShowDiscount
          ? _c(
              "div",
              { staticClass: "card-discount" },
              [
                _c("LightningSvg", { staticClass: "discount-icon" }),
                _vm._v(" "),
                _c("p", [_vm._v("Discount applied")])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._t("plan-access-blurb"),
        _vm._v(" "),
        _c("div", { staticClass: "course-grid" }, [
          _c(
            "div",
            { staticClass: "math-row row" },
            [
              _c("MathSvg", { staticClass: "icon" }),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.mathDescription))
              ])
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isMathFoundationsPlan
            ? _c("div", { staticClass: "all-courses" }, [
                _c(
                  "div",
                  { staticClass: "data-analysis-row row" },
                  [
                    _c("DataAnalysisSvg", { staticClass: "icon" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v("Data Analysis")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "computer-science-row row" },
                  [
                    _c("ComputerScienceSvg", { staticClass: "icon" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v("Computer Science")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "programming-row row" },
                  [
                    _c("ProgrammingSvg", { staticClass: "icon" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v("Programming")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "science-and-engineering-row row" },
                  [
                    _c("ScienceAndEngineeringSvg", { staticClass: "icon" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v("Science and Engineering")
                    ])
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }